import { Serializable } from './Serializable';
import { Constants } from '../utils/constants';
import { CategoryDTO } from './CategoryDTO';

export class UserDTO extends Serializable {
    /*id: number;
    firstName: string;
    lastName: string;
    email: string;
    areaCode: string;
    phone: string;
    profileCode: number;
    profileName: string;
    token: string;
    validationCode: any;
    locations: any;
    commerce: any;*/
    token: string;
    email: string;
    role: string;
    firstName: string;
    lastName: string;
    clientID: string;
    image: string;
    categoryOne: CategoryDTO;
    categoryTwo: CategoryDTO;
    categoryThree: CategoryDTO;
    phrase: string;

    constructor() {
        super();
    }

    get displayName() {
        let displayName = '--';
        if (this.firstName && this.lastName) {
            displayName = this.firstName + ' ' + this.lastName;
        } else if (this.firstName) {
            displayName = this.firstName;
        } else if (this.lastName) {
            displayName = this.lastName;
        }
        return displayName;
    }

    get displayRole() {
        let displayRole = '--';
        switch (this.role) {
            case Constants.ROLES.SUPERADMIN.NAME:
                displayRole = 'GLOBAL.ROLES.SUPERADMIN';
                break;
            case Constants.ROLES.ADMIN.NAME:
                displayRole = 'GLOBAL.ROLES.ADMIN';
                break;
            case Constants.ROLES.LEADER.NAME:
                displayRole = 'GLOBAL.ROLES.LEADER';
                break;
            case Constants.ROLES.COLLABORATOR.NAME:
                displayRole = 'GLOBAL.ROLES.COLLABORATOR';
                break;
            default:
                break;
        }
        return displayRole;
    }

    get displayImageProfile() {
        let imageUrl = './assets/images/portrait/small/default.png';
        if (this.image) {
            imageUrl = this.image;
        }
        return imageUrl;
    }

    isSuperAdmin(): boolean {
        return this.role.toLowerCase() == Constants.ROLES.SUPERADMIN.NAME.toLowerCase()
        || this.role.toLowerCase() == 'superadmin';
    }

    isAdmin(): boolean {
        return this.role.toLowerCase() == Constants.ROLES.ADMIN.NAME.toLowerCase() 
        || this.role.toLowerCase() == 'admin';
    }

    isLeader(): boolean {
        return this.role.toLowerCase() == Constants.ROLES.LEADER.NAME.toLowerCase()
        || this.role.toLowerCase() == 'leader';
    }

    isCollaborator(): boolean {
        return this.role.toLowerCase() == Constants.ROLES.COLLABORATOR.NAME.toLowerCase()
        || this.role.toLowerCase() == 'collaborator';
    }

    isClient(): boolean {
        return this.clientID != null;
    }

}